import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-isc-header',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './isc-header.component.html',
    styleUrls: ['./isc-header.component.scss']
})

export class IscHeaderComponent implements OnInit {
    environment = environment;
    showProfileButton = false;
    showLogoutButton = false;
    showClaimsButton = false;
    showGetHelpButton = true;
    @Input() userType!: string;

    constructor (private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.setFlagsBasedOnUserType();
        this.cdr.detectChanges();
    }

    ngOnChanges(): void {
        this.setFlagsBasedOnUserType();
        this.cdr.detectChanges();
    }

    setFlagsBasedOnUserType(): void {
        if (this.userType === 'unregistered') {
            this.showProfileButton = false;
            this.showLogoutButton = false;
            this.showClaimsButton = true;
        }

        if (this.userType === 'registered') {
            this.showProfileButton = true;
            this.showLogoutButton = true;
            this.showClaimsButton = false;
        }
    }

    navigateToUrl(url: string): void {
        window.location.href = url;
    }

    getClaimsLink(): string {
        return environment.NATIONWIDE.ClaimsLandingPage;
    }

    onLogoutClick(): void {
        this.navigateToUrl(this.environment.AUTH_HEADER_LINKS.logout);
    }

    getProfileLink(): string {
        return this.environment.AUTH_HEADER_LINKS.personalInformation;
    }
}
